import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

interface HeaderProps {
  logoSrc?: string;
  title: string;
  rightContent?: React.ReactNode;
  headerBackground?: string;
  className?: string;
  onLogoClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  logoSrc,
  title,
  rightContent,
  headerBackground,
  className,
  onLogoClick,
}) => {
  const location = useLocation();
  const [isChatPage, setIsChatPage] = useState(false);
  const [isRecentPage, setIsRecentPage] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    setIsChatPage(location.pathname.includes("/chat/"));
    setIsRecentPage(location.pathname.includes("/recent"));

    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, [location]);

  // Hide header on chat page (Chat component has its own header)
  if (isChatPage) {
    return null;
  }

  // Hide header on recent page for mobile/tablet
  if (isRecentPage && (isMobile || isTablet)) {
    return null;
  }

  return (
    <header
      className={`header ${className || ""}`}
      style={{
        background: headerBackground || "transparent",
      }}>
      {logoSrc && (
        <div className="logo">
          <img
            className="w-40 lg:p-4 pt-4"
            src={logoSrc}
            alt="logo"
            onClick={onLogoClick}
            style={{ cursor: onLogoClick ? "pointer" : "default" }}
          />
        </div>
      )}
      <h2 className="text-white font-bold text-xl">{title}</h2>

      <div className="header-right">{rightContent}</div>
    </header>
  );
};

export default Header;
